<template>
  <div>
    <template v-if="!allDay && isScheduled">
      <span v-if="!isSameDay">
        {{ luxonStartDate.toFormat(dateTimeFormat) }}
        <br /><small>until</small>
        {{ luxonEndDate.toFormat(dateTimeFormat) }}
      </span>
      <span v-else>
        {{ luxonStartDate.toFormat(dateFormat) }}, {{ luxonStartDate.toFormat(luxonFormats.TIME) }} - {{ luxonEndDate.toFormat(luxonFormats.TIME) }}
      </span>
    </template>

    <template v-else-if="isScheduled">
      <b>All Day</b><br />
      <span v-if="!isSameDay">
        {{ luxonStartDate.toFormat(dateFormat) }}
        <br /><small>until</small>
        {{ luxonEndDate.toFormat(dateFormat) }}
      </span>
      <span v-else>
        {{ luxonStartDate.toFormat(dateFormat) }}
      </span>
    </template>

    <template v-else>
      <b v-if="unscheduledText" class="block">Unscheduled</b>
      <span>Estimated </span>
      <span>{{ luxonStartDate.toFormat(dateFormat) }}</span>
    </template>

    <span
      v-if="willDisplayTimezone"
      class="text-bold text-underline q-pl-xs"
    >
      {{ timezoneDetails.abbr }}
    </span>

    <div v-if="!withoutLength && !allDay && isScheduled" class="text-caption opaque-80">
      {{ minutesToStr(minutesBetween) }} length
    </div>

    <div v-if="detailedTimezone && willDisplayTimezone">
      <q-chip
        square
        dense
        size="12px"
        class="q-mx-none"
      >
        {{ timezoneDetails.abbr }} | {{ timezoneDetails.zone }} | {{ timezoneDetails.diff_from_gmt }}
      </q-chip>
    </div>
  </div>
</template>

<script>
/**
 * Display the date and time for an appointment
*/
export default {
  props: {
    allDay: {
      type: Boolean,
      default: false
    },
    startDate: {
      type: String,
      required: true
    },
    endDate: {
      type: String,
      required: true
    },
    isScheduled: {
      type: Boolean,
      default: true
    },
    unscheduledText: {
      type: Boolean,
      default: false
    },
    timezone: {
      type: [Object, String],
      default: null
    },
    detailedTimezone: {
      type: Boolean,
      default: false
    },
    withoutLength: {
      type: Boolean,
      default: false
    },
    short: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      timezones: this.$store.getters.getSystemSetting('timezones')
    }
  },
  computed: {
    dateFormat () {
      return this.short ? this.luxonFormats.COMPACT_WORDED_DATE : this.luxonFormats.SHORT_WORDED_DATE
    },
    dateTimeFormat () {
      return this.short ? this.luxonFormats.COMPACT_WORDED_DATE_TIME : this.luxonFormats.SHORT_WORDED_DATE_TIME
    },
    luxonStartDate () {
      return this.luxon.fromSQL(this.startDate)
    },
    luxonEndDate () {
      return this.luxon.fromSQL(this.endDate)
    },
    minutesBetween () {
      return this.luxonEndDate.diff(this.luxonStartDate, 'minutes').toObject().minutes
    },
    isSameDay () {
      return this.luxonStartDate.hasSame(this.luxonEndDate, 'day')
    },
    timezoneDetails () {
      if (!this.timezone) {
        return null
      }

      if (typeof this.timezone === 'string') {
        return this.timezones.find(item => item.zone === this.timezone)
      }
      return this.timezone
    },
    willDisplayTimezone () {
      return !!this.timezoneDetails && (this.company.appointments_always_show_timezone || this.company.timezone !== this.timezoneDetails.zone)
    }
  }
}
</script>
